// Life status of a member, in plain words. Stored values stay as they always
// were (Alive / Deceased) so older records and reports keep working; screens
// show Active / Passed Away.

export const ALIVE = 'Alive';
export const INACTIVE = 'Inactive';
export const TRANSFERRED = 'Transferred';
export const DECEASED = 'Deceased';

export const LIFE_OPTIONS = [
  { value: ALIVE, label: 'Active' },
  { value: INACTIVE, label: 'Inactive' },
  { value: TRANSFERRED, label: 'Transferred' },
  { value: DECEASED, label: 'Passed Away' }
];

const LABELS: Record<string, string> = {
  alive: 'Active', inactive: 'Inactive', transferred: 'Transferred', deceased: 'Passed Away'
};

export const lifeOf = (m?: { status?: string | null } | null): string => {
  const s = String(m?.status || ALIVE).trim().toLowerCase();
  return s === 'inactive' ? INACTIVE : s === 'transferred' ? TRANSFERRED : s === 'deceased' ? DECEASED : ALIVE;
};

export const lifeLabel = (status?: string | null): string =>
  LABELS[String(status || ALIVE).trim().toLowerCase()] || String(status);

/** Active: not inactive, transferred or passed away. */
export const isActiveMember = (m?: { status?: string | null } | null): boolean => lifeOf(m) === ALIVE;

/** Family status words (CLOSED: no living member left — set automatically). */
export const FAMILY_STATUS_LABEL: Record<string, string> = {
  ACTIVE: 'Active', INACTIVE: 'Inactive', TRANSFERRED: 'Transferred', CLOSED: 'Closed'
};
